export const getContractColor = (type, style) => ({
    PREPAYMENTS: { color: '', backgroundColor: '', borderColor:'', tagType: 'success', name: '预付款'},
    FORMAL: { color: '', backgroundColor: '', borderColor: '', tagType: 'warning', name: '正式'},
    CHARGEBACKS: { color: '', backgroundColor: '', borderColor: '', tagType: 'danger', name: '扣款'},
    IMPORT_PREPAYMENTS: { color: '', backgroundColor: '', borderColor: '', tagType: 'primary', name: '老系统预付款'},
    DEVELOPMENT: { color: 'rgb(27, 138, 155)', backgroundColor: 'rgb(209, 252, 250)', tagType: '', borderColor: 'rgb(209,252,250)', name: '研发' },
    ADVANCE_PAYMENT_TRANSFER: { color: '#000000', borderColor: '', backgroundColor: '#99CCFF', tagType: '', name: '预付款转移' },
    TEAM: { color: 'rgb(103, 194, 58)', backgroundColor: 'rgb(240, 249, 235)', tagType: '', borderColor: 'rgb(240,249,235)', name: '团队费用' },
}[type] || { color: '', backgroundColor: '', borderColor: '', tagType: 'info', name: '未知类型'})[style];

export const getInvoiceColor = (type, style) => ({
    RECEIVABLES: {color: '#e13d4b', backgroundColor: '', tagType: 'warning', name: '应收款'},
    PARTIAL_ARRIVAL: {color: '', backgroundColor: '#ffffff', tagType: 'warning', name: '部分到款'},
    PENDING_AUDIT: {color: '', backgroundColor: '', tagType: 'warning', name: '待审核'},
    PENDING_INVOICE: {color: '', backgroundColor: '#ffffff', tagType: 'primary', name: '待开票'},
    PAYMENT: {color: '', backgroundColor: '', tagType: 'success', name: '已回款'},
    PENDING_REFUND: {color: '', backgroundColor: '#ffffff', tagType: 'danger', name: '待退票'},
    REFUND_SUCCESS: {color: '', backgroundColor: '', tagType: '', name: '退票成功'},
    CANCEL_INVOICING: {color: '', backgroundColor: '', tagType: '', name: '取消开票'},
}[type] || {color: '', backgroundColor: '', tagType: 'info', name: '审核未通过'})[style];

export const getStatusColor = (type, style) => ({
    DERELICT: {color: '', backgroundColor: '', tagType: 'info', name: '已终止'},
    DELETED: {color: '', backgroundColor: '', tagType: 'danger', name: '已删除'},
    SUCCESS: {color: '', backgroundColor: '', tagType: 'success', name: '已通过'},
    APPLYING: {color: '', backgroundColor: '', tagType: 'warning', name: '待审核'},
    DEFEAT: {color: '', backgroundColor: '', tagType: 'danger', name: '已驳回'},
    DONE: {color: '', backgroundColor: '', tagType: 'success', name: '已通过'},
    REJECTED: {color: '', backgroundColor: '', tagType: 'danger', name: '已驳回'},
    TO_BE_REVIEWED: {color: '', backgroundColor: '', tagType: 'warning', name: '待审核'},
    TO_BE_CLAIMED: {color: '', backgroundColor: '#ffffff', tagType: 'danger', name: '待认领'},
}[type] || {color: '', backgroundColor: '', tagType: 'info', name: 'NA'})[style];

export const getSignColor = (type, style) => ({
    NOT_APPLYING: { color: '', backgroundColor: '', tagType: 'info', name: '未申请', icon: 'fas fa-circle-notch status-icon' },
    APPLY: { color: '', backgroundColor: '', tagType: 'warning', name: '待审核', icon: 'fas fa-clock status-icon' },
    REJECTED: { color: '', backgroundColor: '', tagType: 'danger', name: '已驳回', icon: 'fas fa-ban status-icon' },
    SIGN_FLOW_INITIATED: { color: '', backgroundColor: '#ffffff', tagType: 'success', name: '签署已发起', icon: 'fas fa-file-export status-icon' },
    OPERATOR_READ: { color: '', backgroundColor: '#ffffff', tagType: 'warning', name: '甲方已读', icon: 'fas fa-eye status-icon' },
    SIGNED: { color: '', backgroundColor: '', tagType: 'success', name: '甲方已签', icon: 'fas fa-check-circle status-icon' },
    RETRACTED: { color: '', backgroundColor: '#ffffff', tagType: 'danger', name: '已撤销', icon: 'fas fa-undo status-icon' },
    EXPIRED: { color: '', backgroundColor: '', tagType: 'info', name: '已过期', icon: 'fas fa-clock status-icon' },
    INITIATION_FAILED: { color: '', backgroundColor: '', tagType: 'danger', name: '签署发起失败', icon: 'fas fa-times-circle status-icon' },
    VISA_REFUSAL: { color: '', backgroundColor: '#ffffff', tagType: 'danger', name: '甲方拒签', icon: 'fas fa-times status-icon' },
    INITIATION: {
        color: "#007BFF",
        backgroundColor: "#ffffff",
        tagType: "primary",
        name: "签署发起中",
        icon: "fas fa-spinner status-icon"
    },
    AUTO: { color: '', backgroundColor: '', tagType: 'success', name: '自流转', icon: 'fas fa-check-circle status-icon' },
  }[type] || { color: '', backgroundColor: '', tagType: 'info', name: 'NA' })[style];

export const getMaterialColor = (type, style) => ({
    PROTECT_REAGENT: {color: '', backgroundColor: '', tagType: 'success', name: '保护剂'},
    SINGLE_PAGER: { color: '', backgroundColor: '', tagType: 'warning', name: '宣传品'},
    NAME_CARD: {color: '', backgroundColor: '', tagType: 'danger', name: '名片'},
    DRY_ICE: {color: '', backgroundColor: '#ffffff', tagType: 'danger', name: '干冰'},
    OTHER: {color: '', backgroundColor: '#ffffff', tagType: 'warning', name: '其他'},
    GIFT: {color: '', backgroundColor: '', tagType: '', name: '礼品'},
}[type] || {color: '', backgroundColor: '', tagType: 'info', name: '未知类型'})[style];

export const getReportGenerationColor = (type, style) => ({
    DONE: { color: '', backgroundColor: '', tagType: 'success', name: '已完成', icon: 'fas fa-file-export status-icon' },
    RUN_FAILED: { color: '', backgroundColor: '', tagType: 'danger', name: '运行失败', icon: 'fas fa-times-circle status-icon' },
    RUNNING: { color: "#007BFF", backgroundColor: "#ffffff", tagType: "primary", name: "运行中", icon: "fas fa-spinner status-icon" },
}[type] || { color: '', backgroundColor: '', tagType: 'info', name: 'NA' })[style];

export const getAdvanceColor = (type, style) => ({
    REJECTED: { color: '', backgroundColor: '', tagType: 'danger', name: '已驳回' },
    NONE: { color: '', backgroundColor: '', tagType: 'info', name: '无' },
    TO_BE_CLAIMED: { color: '', backgroundColor: '', tagType: 'success', name: '待认领'},
    CLAIM_PENDING_APPROVAL: { color: '', backgroundColor: '', tagType: 'warning', name: '认领待审批'},
    PAID: { color: "#007BFF", backgroundColor: "#ffffff", tagType: "primary", name: "已垫付"},
    PENDING_REFUND: { color: '', backgroundColor: '', tagType: 'success', name: '待退款'},
    DELETED: { color: '', backgroundColor: '#ffffff', tagType: 'danger', name: '已删除' },
    REFUNDED: { color: '', backgroundColor: '', tagType: 'danger', name: '已退款'}
}[type] || { color: '', backgroundColor: '', tagType: 'info', name: 'NA' })[style];
